import { Directive, input } from '@angular/core';
import { AlertDialog } from './alert-dialog';

@Directive({
  selector: '[alertDialogTriggerFor]',
  host: {
    '(click)': 'open()',
  },
})
export class AlertDialogTrigger {
  // Inputs / Outputs
  readonly alertDialog = input.required<AlertDialog>({
    alias: 'alertDialogTriggerFor',
  });

  open() {
    this.alertDialog().open.set(true);
  }
}
